/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { TutorAITokenUsageReportViewModel } from "../types/TutorAITokenUsageReportViewModel.ts";
import { tutorAIDailyUsageViewModelSchema } from "./tutorAIDailyUsageViewModelSchema.ts";
import { tutorAIMonthlyHistoryViewModelSchema } from "./tutorAIMonthlyHistoryViewModelSchema.ts";
import { tutorAITokenBreakdownViewModelSchema } from "./tutorAITokenBreakdownViewModelSchema.ts";

export const tutorAITokenUsageReportViewModelSchema = z.object({
  personId: z.number().int().describe("ID da pessoa consultada.").nullish(),
  periodStart: z
    .string()
    .describe("Data de início do período consultado (formato yyyy-MM-dd).")
    .nullish(),
  periodEnd: z
    .string()
    .describe("Data de fim do período consultado (formato yyyy-MM-dd).")
    .nullish(),
  periodTokensUsed: z
    .number()
    .int()
    .describe("Total de tokens consumidos no período consultado.")
    .nullish(),
  currentMonth: z
    .string()
    .describe(
      "Mês corrente utilizado como referência para os limites (formato yyyy-MM).",
    )
    .nullish(),
  dailyTokensUsed: z
    .number()
    .int()
    .describe("Tokens consumidos no dia corrente.")
    .nullish(),
  dailyLimit: z
    .number()
    .int()
    .describe(
      "Limite diário de tokens configurado para o aluno. Zero indica ausência de limite individual.",
    )
    .nullish(),
  weeklyTokensUsed: z
    .number()
    .int()
    .describe("Tokens consumidos na semana corrente.")
    .nullish(),
  weeklyLimit: z
    .number()
    .int()
    .describe(
      "Limite semanal de tokens configurado para o aluno. Zero indica ausência de limite individual.",
    )
    .nullish(),
  monthlyTokensUsed: z
    .number()
    .int()
    .describe("Tokens consumidos no mês corrente.")
    .nullish(),
  monthlyLimit: z
    .number()
    .int()
    .describe(
      "Limite mensal de tokens configurado para o aluno. Zero indica ausência de limite individual.",
    )
    .nullish(),
  monthlyPercentUsed: z
    .number()
    .describe(
      "Percentual do limite mensal já consumido (0–100). Zero quando não houver limite configurado.",
    )
    .nullish(),
  limitEnabled: z
    .boolean()
    .describe(
      "Indica se o controle de limites de tokens está habilitado para o aluno.",
    )
    .nullish(),
  dailyLimitReached: z
    .boolean()
    .describe("Indica se o limite diário foi atingido no dia corrente.")
    .nullish(),
  weeklyLimitReached: z
    .boolean()
    .describe("Indica se o limite semanal foi atingido na semana corrente.")
    .nullish(),
  monthlyLimitReached: z
    .boolean()
    .describe("Indica se o limite mensal foi atingido no mês corrente.")
    .nullish(),
  breakdown: z
    .array(z.lazy(() => tutorAITokenBreakdownViewModelSchema))
    .describe(
      "Detalhamento do consumo de tokens agrupado por provedor de IA e tipo de operação.",
    )
    .nullish(),
  dailyUsage: z
    .array(z.lazy(() => tutorAIDailyUsageViewModelSchema))
    .describe(
      "Série histórica do consumo diário de tokens dentro do período consultado.",
    )
    .nullish(),
  history: z
    .array(z.lazy(() => tutorAIMonthlyHistoryViewModelSchema))
    .describe(
      "Histórico mensal de consumo de tokens para os meses anteriores ao período.",
    )
    .nullish(),
}) as unknown as ToZod<TutorAITokenUsageReportViewModel>;
